// Widget Templates Library
// This file contains the definitions for available widget templates.

const WIDGET_TEMPLATES = [
    {
        id: 'energy_card_compact',
        name: 'Enerji Analizörü - Kompakt Kart',
        description: 'Gerilim, Akım ve Güç değerlerini gösteren modern bir kart.',
        
        // Veri Giriş Noktaları (Kullanıcının Tag eşleştireceği yerler)
        slots: [
            { key: 'total_power', label: 'Toplam Güç (kW)', type: 'number', unit: 'kW' },
            { key: 'total_energy', label: 'Toplam Enerji (kWh)', type: 'number', unit: 'kWh' },
            { key: 'max_power', label: 'Gauge Max Değer (Skala)', type: 'number', unit: 'kW', default: 150 },
            { key: 'v1', label: 'Gerilim L1 (V)', type: 'number', unit: 'V' },
            { key: 'v2', label: 'Gerilim L2 (V)', type: 'number', unit: 'V' },
            { key: 'v3', label: 'Gerilim L3 (V)', type: 'number', unit: 'V' },
            { key: 'i1', label: 'Akım L1 (A)', type: 'number', unit: 'A' },
            { key: 'i2', label: 'Akım L2 (A)', type: 'number', unit: 'A' },
            { key: 'i3', label: 'Akım L3 (A)', type: 'number', unit: 'A' },
            { key: 'p1', label: 'Güç L1 (kW)', type: 'number', unit: 'kW' },
            { key: 'p2', label: 'Güç L2 (kW)', type: 'number', unit: 'kW' },
            { key: 'p3', label: 'Güç L3 (kW)', type: 'number', unit: 'kW' },
            { key: 'freq', label: 'Frekans (Hz)', type: 'number', unit: 'Hz' }
        ],

        // HTML Şablonu ({{uid}} ve {{key}} yer tutucuları içerir)
        // Not: <script> blokları buraya konmaz, widget motoru tarafından yönetilir.
        // HTML Şablonu
        html: `
        <div class="energy-card-widget h-100" style="font-family: 'Segoe UI', sans-serif; min-width: 300px; min-height: 300px;">
            <div class="card h-100 shadow-sm" style="background: #212631; color: #fff; border: 1px solid #5a6475;">
                <!-- Header -->
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold text-white" style="letter-spacing: 0.5px; font-size: 0.85rem;">{{title}}</span>
                    <span class="badge bg-black text-warning border border-secondary" id="{{uid}}_freq_badge" style="min-width: 60px;">-- Hz</span>
                </div>
        
                <div class="card-body p-0 d-flex flex-column">
                    <!-- Gauge Section -->
                    <div class="d-flex flex-column justify-content-end align-items-center position-relative pt-3 pb-0" style="flex: 0 0 160px; background: rgba(0,0,0,0.2);">
                         
                         <!-- SVG Gauge -->
                         <div style="width: 220px; height: 110px; position: relative;">
                            
                            <!-- Gauge SVG -->
                            <svg viewBox="0 0 140 70" style="width: 100%; height: 100%; overflow: visible;">
                                <defs>
                                    <linearGradient id="{{uid}}_grad" x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop offset="0%" style="stop-color:#321fdb;stop-opacity:1" /> <!-- Primary Blue -->
                                        <stop offset="100%" style="stop-color:#f9b115;stop-opacity:1" /> <!-- Warning Yellow -->
                                    </linearGradient>
                                </defs>
                                
                                <!-- Arka Plan Track -->
                                <path d="M 20,70 A 50,50 0 0,1 120,70" fill="none" stroke="#363d4d" stroke-width="12" stroke-linecap="round" />
                                
                                <!-- Renkli Path (Value) -->
                                <path id="{{uid}}_gaugePath" 
                                      d="M 20,70 A 50,50 0 0,1 120,70" 
                                      fill="none" 
                                      stroke="url(#{{uid}}_grad)" 
                                      stroke-width="12" 
                                      stroke-linecap="round" 
                                      stroke-dasharray="157.1" 
                                      stroke-dashoffset="157.1" 
                                      style="transition: stroke-dashoffset 0.5s ease-out;" 
                                />
                            </svg>

                            <!-- Labels (0 ve Max) -->
                            <div class="position-absolute text-secondary font-monospace" style="bottom: -5px; left: 15px; font-size: 0.75rem;">0</div>
                            <div class="position-absolute text-secondary font-monospace" style="bottom: -5px; right: 15px; font-size: 0.75rem;" id="{{uid}}_gaugeMax">--</div>
                            
                            <!-- Ortadaki Büyük Değer -->
                            <div class="position-absolute w-100 text-center" style="bottom: 5px; left: 0;">
                                <div class="mb-0 fw-bold text-white" id="{{uid}}_total_power" style="font-size: 2.2rem; line-height: 1; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">--</div>
                                <div class="text-secondary fw-bold" style="font-size: 0.7rem; letter-spacing: 1px;">kW</div>
                            </div>
                        </div>
                         
                         <!-- Toplam Enerji -->
                         <div class="text-center mt-2 w-100 py-2" style="border-top: 1px solid rgba(255,255,255,0.1);">
                            <div class="text-light fw-bold font-monospace" id="{{uid}}_total_energy" style="font-size: 1.1rem; opacity: 0.9;">-- kWh</div>
                         </div>
                    </div>
        
                    <!-- Scrollable List Section -->
                    <div class="flex-grow-1 overflow-auto px-3 pb-2 custom-scrollbar">
                        
                        <!-- Voltaj Section -->
                        <div class="mb-3">
                            <div class="d-flex align-items-center mb-1">
                                <i class="fas fa-bolt text-warning me-2" style="font-size: 0.8rem;"></i>
                                <span class="text-uppercase text-muted fw-bold" style="font-size: 0.7rem;">Gerilim (Volt)</span>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L1</span>
                                    <span id="{{uid}}_v1">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-warning" id="{{uid}}_v1_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L2</span>
                                    <span id="{{uid}}_v2">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-warning" id="{{uid}}_v2_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L3</span>
                                    <span id="{{uid}}_v3">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-warning" id="{{uid}}_v3_bar" style="width: 0%"></div>
                                </div>
                            </div>
                        </div>

                        <!-- Akım Section -->
                        <div class="mb-3">
                            <div class="d-flex align-items-center mb-1">
                                <i class="fas fa-wave-square text-danger me-2" style="font-size: 0.8rem;"></i>
                                <span class="text-uppercase text-muted fw-bold" style="font-size: 0.7rem;">Akım (Amper)</span>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L1</span>
                                    <span id="{{uid}}_i1">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-danger" id="{{uid}}_i1_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L2</span>
                                    <span id="{{uid}}_i2">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-danger" id="{{uid}}_i2_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>L3</span>
                                    <span id="{{uid}}_i3">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-danger" id="{{uid}}_i3_bar" style="width: 0%"></div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Güç Section -->
                        <div class="mb-1">
                            <div class="d-flex align-items-center mb-1">
                                <i class="fas fa-plug text-success me-2" style="font-size: 0.8rem;"></i>
                                <span class="text-uppercase text-muted fw-bold" style="font-size: 0.7rem;">Güç (kW)</span>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>P1</span>
                                    <span id="{{uid}}_p1">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-success" id="{{uid}}_p1_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item mb-1">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>P2</span>
                                    <span id="{{uid}}_p2">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-success" id="{{uid}}_p2_bar" style="width: 0%"></div>
                                </div>
                            </div>
                            <div class="list-item">
                                <div class="d-flex justify-content-between text-white" style="font-size: 0.85rem;">
                                    <span>P3</span>
                                    <span id="{{uid}}_p3">--</span>
                                </div>
                                <div class="progress" style="height: 4px; background: #323a49;">
                                    <div class="progress-bar bg-success" id="{{uid}}_p3_bar" style="width: 0%"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <style>
                .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: #212631; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #4f5d73; border-radius: 2px; }
            </style>
        </div>
        `,

        // Widget Render Edildikten Sonra ve Veri Geldiğinde Çalışacak Logic
        // Bu kısım Widget Engine tarafından işletilecektir.
        renderer: {
            // Statik değerler
            limits: {
                totalPower: 150,
                voltage: 250,
                current: 100,
                power: 50
            },
            
            // Veri geldiğinde DOM güncelleme mantığı
            onUpdate: function(uid, data, elements) {
                // Helper to update text and bar
                const updateItem = (key, val, max) => {
                    const elText = document.getElementById(`${uid}_${key}`);
                    const elBar = document.getElementById(`${uid}_${key}_bar`);
                    
                    if(val !== undefined && val !== null) {
                        const num = parseFloat(val);
                        if(elText) elText.textContent = isNaN(num) ? val : num.toFixed(2);
                        if(elBar) {
                            let pct = (Math.abs(num) / max) * 100;
                            if(pct > 100) pct = 100; if(pct < 0) pct = 0;
                            elBar.style.width = `${pct}%`;
                        }
                    }
                };

                updateItem('v1', data.v1, 250);
                updateItem('v2', data.v2, 250);
                updateItem('v3', data.v3, 250);
                
                updateItem('i1', data.i1, 100);
                updateItem('i2', data.i2, 100);
                updateItem('i3', data.i3, 100);

                updateItem('p1', data.p1, 50);
                updateItem('p2', data.p2, 50);
                updateItem('p3', data.p3, 50);

                if(data.freq) {
                    const el = document.getElementById(`${uid}_freq_badge`);
                    if(el) el.textContent = parseFloat(data.freq).toFixed(1) + ' Hz';
                }
                
                // Update Total Energy
                if(data.total_energy) {
                    const el = document.getElementById(`${uid}_total_energy`);
                    if(el) {
                        const val = parseFloat(data.total_energy);
                        el.textContent = (isNaN(val) ? data.total_energy : val.toFixed(1)) + ' kWh';
                    }
                }


                    // Update Gauge
                if(data.total_power) {
                    const val = parseFloat(data.total_power);
                    const elVal = document.getElementById(`${uid}_total_power`);
                    if(elVal) elVal.textContent = isNaN(val) ? '--' : val.toFixed(1);

                    const maxVal = (data.max_power && parseFloat(data.max_power) > 0) ? parseFloat(data.max_power) : 200; 
                    
                    // Update Max Label
                    const elMax = document.getElementById(`${uid}_gaugeMax`);
                    if(elMax) elMax.textContent = maxVal;

                    // Updated for R=50 Arc (Length approx 157.1)
                    const maxDash = 157.1; 
                    
                    let pct = Math.abs(val) / maxVal;
                    if(pct > 1) pct = 1; if(pct < 0) pct = 0;
                    
                    // Offset: 157.1(empty) -> 0(full)
                    const offset = maxDash * (1 - pct);
                    
                    // Match the ID in HTML: {{uid}}_gaugePath
                    const elPath = document.getElementById(`${uid}_gaugePath`);
                    if(elPath) elPath.style.strokeDashoffset = offset.toFixed(1);
                }
            }
        }
    },
    {
        id: 'energy_card_digital',
        name: 'Enerji Analizörü - Dijital Tablo',
        description: 'Göstergeli ve kutulu dijital değer tablosu.',
        
        // Veri Giriş Noktaları
        slots: [
            { key: 'total_power', label: 'Toplam Güç (kW)', type: 'number', unit: 'kW' },
            { key: 'total_energy', label: 'Toplam Enerji (kWh)', type: 'number', unit: 'kWh' },
            { key: 'max_power', label: 'Gauge Max Değer (Skala)', type: 'number', unit: 'kW', default: 150 },
            { key: 'v1', label: 'Gerilim L1 (V)', type: 'number', unit: 'V' },
            { key: 'v2', label: 'Gerilim L2 (V)', type: 'number', unit: 'V' },
            { key: 'v3', label: 'Gerilim L3 (V)', type: 'number', unit: 'V' },
            { key: 'i1', label: 'Akım L1 (A)', type: 'number', unit: 'A' },
            { key: 'i2', label: 'Akım L2 (A)', type: 'number', unit: 'A' },
            { key: 'i3', label: 'Akım L3 (A)', type: 'number', unit: 'A' },
            { key: 'p1', label: 'Güç L1 (kW)', type: 'number', unit: 'kW' },
            { key: 'p2', label: 'Güç L2 (kW)', type: 'number', unit: 'kW' },
            { key: 'p3', label: 'Güç L3 (kW)', type: 'number', unit: 'kW' },
            { key: 'freq', label: 'Frekans (Hz)', type: 'number', unit: 'Hz' }
        ],

        // HTML Şablonu
        html: `
        <div class="energy-card-widget h-100" style="font-family: 'Segoe UI', sans-serif; min-width: 300px; min-height: 300px;">
            <div class="card h-100 shadow-sm" style="background: #212631; color: #fff; border: 1px solid #5a6475;">
                <!-- Header -->
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold text-white" style="letter-spacing: 0.5px; font-size: 0.85rem;">{{title}}</span>
                    <span class="badge bg-black text-warning border border-secondary" id="{{uid}}_freq_badge" style="min-width: 60px;">-- Hz</span>
                </div>
        
                <div class="card-body p-0 d-flex flex-column">
                    <!-- Gauge Section -->
                    <div class="d-flex flex-column justify-content-end align-items-center position-relative pt-3 pb-0" style="flex: 0 0 160px; background: rgba(0,0,0,0.2);">
                         
                         <!-- SVG Gauge -->
                         <div style="width: 220px; height: 110px; position: relative;">
                            <svg viewBox="0 0 140 70" style="width: 100%; height: 100%; overflow: visible;">
                                <defs>
                                    <linearGradient id="{{uid}}_grad" x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop offset="0%" style="stop-color:#321fdb;stop-opacity:1" /> 
                                        <stop offset="100%" style="stop-color:#f9b115;stop-opacity:1" /> 
                                    </linearGradient>
                                </defs>
                                <path d="M 20,70 A 50,50 0 0,1 120,70" fill="none" stroke="#363d4d" stroke-width="12" stroke-linecap="round" />
                                <path id="{{uid}}_gaugePath" 
                                      d="M 20,70 A 50,50 0 0,1 120,70" 
                                      fill="none" 
                                      stroke="url(#{{uid}}_grad)" 
                                      stroke-width="12" 
                                      stroke-linecap="round" 
                                      stroke-dasharray="157.1" 
                                      stroke-dashoffset="157.1" 
                                      style="transition: stroke-dashoffset 0.5s ease-out;" 
                                />
                            </svg>
                            <div class="position-absolute text-secondary font-monospace" style="bottom: -5px; left: 15px; font-size: 0.75rem;">0</div>
                            <div class="position-absolute text-secondary font-monospace" style="bottom: -5px; right: 15px; font-size: 0.75rem;" id="{{uid}}_gaugeMax">--</div>
                            <div class="position-absolute w-100 text-center" style="bottom: 5px; left: 0;">
                                <div class="mb-0 fw-bold text-white" id="{{uid}}_total_power" style="font-size: 2.2rem; line-height: 1; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">--</div>
                                <div class="text-secondary fw-bold" style="font-size: 0.7rem; letter-spacing: 1px;">kW</div>
                            </div>
                        </div>
                         
                         <!-- Toplam Enerji -->
                         <div class="text-center mt-2 w-100 py-2" style="border-top: 1px solid rgba(255,255,255,0.1);">
                            <div class="text-light fw-bold font-monospace" id="{{uid}}_total_energy" style="font-size: 1.1rem; opacity: 0.9;">-- kWh</div>
                         </div>
                    </div>
        
                    <!-- Digital Table Section -->
                    <div class="flex-grow-1 p-3 d-flex flex-column justify-content-center bg-dark">
                        
                        <!-- Header Labels -->
                        <div class="row g-2 mb-1 text-center">
                            <div class="col-4 text-muted text-uppercase" style="font-size:0.7rem; font-weight:700;">L1</div>
                            <div class="col-4 text-muted text-uppercase" style="font-size:0.7rem; font-weight:700;">L2</div>
                            <div class="col-4 text-muted text-uppercase" style="font-size:0.7rem; font-weight:700;">L3</div>
                        </div>

                        <!-- Voltage Row -->
                        <div class="row g-2 mb-2">
                            <div class="col-12 px-1"><div class="border-bottom border-secondary mb-1"></div></div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-warning p-1" style="font-size:0.6rem;">V</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_v1">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-warning p-1" style="font-size:0.6rem;">V</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_v2">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-warning p-1" style="font-size:0.6rem;">V</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_v3">--</div>
                                </div>
                            </div>
                        </div>

                        <!-- Current Row -->
                        <div class="row g-2 mb-2">
                             <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-danger p-1" style="font-size:0.6rem;">A</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_i1">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-danger p-1" style="font-size:0.6rem;">A</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_i2">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-danger p-1" style="font-size:0.6rem;">A</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_i3">--</div>
                                </div>
                            </div>
                        </div>

                        <!-- Power Row -->
                        <div class="row g-2">
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-success p-1" style="font-size:0.6rem;">kW</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_p1">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-success p-1" style="font-size:0.6rem;">kW</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_p2">--</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="p-2 text-center border border-secondary rounded position-relative" style="background: rgba(255,255,255,0.03);">
                                    <span class="position-absolute top-0 start-0 badge bg-transparent text-success p-1" style="font-size:0.6rem;">kW</span>
                                    <div class="fw-bold text-white mt-1 font-monospace" id="{{uid}}_p3">--</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `,

        // Widget Render Logic
        renderer: {
            onUpdate: function(uid, data, elements) {
                // Helper to update text 
                const updateText = (key, val) => {
                    const elText = document.getElementById(`${uid}_${key}`);
                    if(val !== undefined && val !== null && elText) {
                        const num = parseFloat(val);
                        elText.textContent = isNaN(num) ? val : num.toFixed(2);
                    }
                };

                updateText('v1', data.v1);
                updateText('v2', data.v2);
                updateText('v3', data.v3);
                
                updateText('i1', data.i1);
                updateText('i2', data.i2);
                updateText('i3', data.i3);

                updateText('p1', data.p1);
                updateText('p2', data.p2);
                updateText('p3', data.p3);

                if(data.freq) {
                    const el = document.getElementById(`${uid}_freq_badge`);
                    if(el) el.textContent = parseFloat(data.freq).toFixed(1) + ' Hz';
                }
                
                // Update Total Energy
                if(data.total_energy) {
                    const el = document.getElementById(`${uid}_total_energy`);
                    if(el) {
                        const val = parseFloat(data.total_energy);
                        el.textContent = (isNaN(val) ? data.total_energy : val.toFixed(1)) + ' kWh';
                    }
                }

                // Update Gauge
                if(data.total_power) {
                    const val = parseFloat(data.total_power);
                    const elVal = document.getElementById(`${uid}_total_power`);
                    if(elVal) elVal.textContent = isNaN(val) ? '--' : val.toFixed(1);

                    const maxVal = (data.max_power && parseFloat(data.max_power) > 0) ? parseFloat(data.max_power) : 200; 
                    const elMax = document.getElementById(`${uid}_gaugeMax`);
                    if(elMax) elMax.textContent = maxVal;

                    const maxDash = 157.1; 
                    let pct = Math.abs(val) / maxVal;
                    if(pct > 1) pct = 1; if(pct < 0) pct = 0;
                    
                    const offset = maxDash * (1 - pct);
                    
                    const elPath = document.getElementById(`${uid}_gaugePath`);
                    if(elPath) elPath.style.strokeDashoffset = offset.toFixed(1);
                }
            }
        }
    },

    // ================================================================
    // KONTROL GRUBU WIDGET TEMPLATE'LERİ
    // Motor ve ekipman kontrol durumlarını görselleştirme
    // ================================================================

    {
        id: 'control_motor_status',
        name: 'Motor Kontrol Durumu',
        description: 'Motor çalışma durumu, mod (Auto/Man) ve hata durumunu gösteren kompakt kart. Tıklandığında kontrol popup açar.',

        slots: [
            { key: 'running', label: 'Çalışıyor (Bool)', type: 'bool', unit: '' },
            { key: 'auto_mode', label: 'Auto Mod (Bool)', type: 'bool', unit: '' },
            { key: 'fault', label: 'Arıza (Bool)', type: 'bool', unit: '' },
            { key: 'runtime', label: 'Çalışma Süresi (saat)', type: 'number', unit: 'h' }
        ],

        html: `
        <div class="motor-status-widget" style="font-family: 'Segoe UI', sans-serif; cursor: pointer;" 
             onclick="if(window.ControlPopupManager) window.ControlPopupManager.open('control-onoff-auto', {rootTag: this.dataset.rootTag || '', title: '{{title}}'})">
            <div class="card h-100" style="background: #212631; color: #fff; border: 1px solid #5a6475; min-width: 220px;">
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold" style="font-size: 0.8rem; letter-spacing: 0.5px;">{{title}}</span>
                    <span class="badge" id="{{uid}}_mode_badge" style="font-size: 0.7rem; background: #3a3d52;">--</span>
                </div>
                <div class="card-body py-3 text-center">
                    <div class="d-flex justify-content-center align-items-center gap-3 mb-2">
                        <div id="{{uid}}_status_icon" style="width:48px; height:48px; border-radius:50%; background:#3a3d52; display:flex; align-items:center; justify-content:center; transition: all 0.3s;">
                            <i class="fas fa-cog" style="font-size:24px; color:#8a8ea8;"></i>
                        </div>
                        <div class="text-start">
                            <div id="{{uid}}_status_text" style="font-size:1.1rem; font-weight:600; color:#8a8ea8;">DURUM BİLİNMİYOR</div>
                            <div id="{{uid}}_runtime_text" style="font-size:0.75rem; color:#636f83;">-- saat</div>
                        </div>
                    </div>
                    <div id="{{uid}}_fault_bar" style="display:none; background:#e55353; color:#fff; padding:4px 8px; border-radius:4px; font-size:0.75rem; font-weight:600;">
                        <i class="fas fa-exclamation-triangle"></i> ARIZA
                    </div>
                </div>
            </div>
        </div>`,

        renderer: {
            onUpdate: function(uid, data, elements) {
                const isRunning = data.running === true || data.running === 1 || data.running === 'true';
                const isAuto = data.auto_mode === true || data.auto_mode === 1 || data.auto_mode === 'true';
                const hasFault = data.fault === true || data.fault === 1 || data.fault === 'true';

                // Status icon
                const iconEl = document.getElementById(`${uid}_status_icon`);
                if (iconEl) {
                    if (hasFault) {
                        iconEl.style.background = 'rgba(229,83,83,0.2)';
                        iconEl.innerHTML = '<i class="fas fa-exclamation-triangle" style="font-size:24px; color:#e55353;"></i>';
                    } else if (isRunning) {
                        iconEl.style.background = 'rgba(46,184,92,0.2)';
                        iconEl.innerHTML = '<i class="fas fa-cog fa-spin" style="font-size:24px; color:#2eb85c;"></i>';
                    } else {
                        iconEl.style.background = '#3a3d52';
                        iconEl.innerHTML = '<i class="fas fa-cog" style="font-size:24px; color:#8a8ea8;"></i>';
                    }
                }

                // Status text
                const txtEl = document.getElementById(`${uid}_status_text`);
                if (txtEl) {
                    if (hasFault) { txtEl.textContent = 'ARIZA'; txtEl.style.color = '#e55353'; }
                    else if (isRunning) { txtEl.textContent = 'ÇALIŞIYOR'; txtEl.style.color = '#2eb85c'; }
                    else { txtEl.textContent = 'DURDU'; txtEl.style.color = '#8a8ea8'; }
                }

                // Mode badge
                const modeEl = document.getElementById(`${uid}_mode_badge`);
                if (modeEl) {
                    modeEl.textContent = isAuto ? 'AUTO' : 'MAN';
                    modeEl.style.background = isAuto ? '#3399ff' : '#f9b115';
                    modeEl.style.color = isAuto ? '#fff' : '#1e2130';
                }

                // Runtime
                const rtEl = document.getElementById(`${uid}_runtime_text`);
                if (rtEl && data.runtime !== undefined) {
                    rtEl.textContent = `${parseFloat(data.runtime).toFixed(1)} saat`;
                }

                // Fault bar
                const faultEl = document.getElementById(`${uid}_fault_bar`);
                if (faultEl) { faultEl.style.display = hasFault ? 'block' : 'none'; }
            }
        }
    },

    {
        id: 'control_valve_status',
        name: 'Vana/Oransal Kontrol Durumu',
        description: 'Oransal vana veya damper pozisyonunu yüzde bar ile gösteren kart. Tıklandığında oransal kontrol popup açar.',

        slots: [
            { key: 'position', label: 'Pozisyon (%)', type: 'number', unit: '%' },
            { key: 'setpoint', label: 'Set Point (%)', type: 'number', unit: '%' },
            { key: 'auto_mode', label: 'Auto Mod (Bool)', type: 'bool', unit: '' },
            { key: 'running', label: 'Aktif (Bool)', type: 'bool', unit: '' }
        ],

        html: `
        <div class="valve-status-widget" style="font-family: 'Segoe UI', sans-serif; cursor: pointer;"
             onclick="if(window.ControlPopupManager) window.ControlPopupManager.open('control-proportional', {rootTag: this.dataset.rootTag || '', title: '{{title}}'})">
            <div class="card h-100" style="background: #212631; color: #fff; border: 1px solid #5a6475; min-width: 220px;">
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold" style="font-size: 0.8rem; letter-spacing: 0.5px;">{{title}}</span>
                    <span class="badge" id="{{uid}}_v_mode" style="font-size: 0.7rem; background: #3a3d52;">--</span>
                </div>
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-end mb-1">
                        <span style="font-size:0.7rem; color:#636f83; text-transform:uppercase;">Pozisyon</span>
                        <span id="{{uid}}_v_pos_val" style="font-size:1.5rem; font-weight:700; color:#e4e6eb;">--%</span>
                    </div>
                    <div style="height:10px; background:#3a3d52; border-radius:5px; overflow:hidden; position:relative;">
                        <div id="{{uid}}_v_pos_bar" style="height:100%; width:0%; background: linear-gradient(90deg, #321fdb, #3399ff); border-radius:5px; transition: width 0.5s ease;"></div>
                        <div id="{{uid}}_v_sp_marker" style="position:absolute; top:-2px; width:3px; height:14px; background:#f9b115; border-radius:2px; transition: left 0.5s ease; left:0%;"></div>
                    </div>
                    <div class="d-flex justify-content-between mt-1" style="font-size:0.65rem; color:#636f83;">
                        <span>0%</span>
                        <span>SP: <span id="{{uid}}_v_sp_val" style="color:#f9b115;">--</span>%</span>
                        <span>100%</span>
                    </div>
                    <div class="mt-2 text-center">
                        <span id="{{uid}}_v_active" class="badge" style="font-size:0.7rem; background:#3a3d52;">--</span>
                    </div>
                </div>
            </div>
        </div>`,

        renderer: {
            onUpdate: function(uid, data, elements) {
                const pos = parseFloat(data.position) || 0;
                const sp = parseFloat(data.setpoint) || 0;
                const isAuto = data.auto_mode === true || data.auto_mode === 1 || data.auto_mode === 'true';
                const isActive = data.running === true || data.running === 1 || data.running === 'true';

                // Position value + bar
                const posVal = document.getElementById(`${uid}_v_pos_val`);
                if (posVal) posVal.textContent = pos.toFixed(1) + '%';

                const posBar = document.getElementById(`${uid}_v_pos_bar`);
                if (posBar) posBar.style.width = Math.min(100, Math.max(0, pos)).toFixed(1) + '%';

                // Setpoint marker + value
                const spMarker = document.getElementById(`${uid}_v_sp_marker`);
                if (spMarker) spMarker.style.left = Math.min(100, Math.max(0, sp)).toFixed(1) + '%';

                const spVal = document.getElementById(`${uid}_v_sp_val`);
                if (spVal) spVal.textContent = sp.toFixed(1);

                // Mode badge
                const modeEl = document.getElementById(`${uid}_v_mode`);
                if (modeEl) {
                    modeEl.textContent = isAuto ? 'AUTO' : 'MAN';
                    modeEl.style.background = isAuto ? '#3399ff' : '#f9b115';
                    modeEl.style.color = isAuto ? '#fff' : '#1e2130';
                }

                // Active badge
                const activeEl = document.getElementById(`${uid}_v_active`);
                if (activeEl) {
                    activeEl.textContent = isActive ? 'AKTİF' : 'PASİF';
                    activeEl.style.background = isActive ? 'rgba(46,184,92,0.2)' : '#3a3d52';
                    activeEl.style.color = isActive ? '#2eb85c' : '#8a8ea8';
                }
            }
        }
    },

    // ================================================================
    // TANK SEVİYE GAUGE WIDGET
    // Sıvı seviye göstergesi - dikey tank görselleştirme
    // ================================================================

    {
        id: 'tank_level_gauge',
        name: 'Tank Seviye Göstergesi',
        description: 'Dikey tank şeklinde sıvı seviyesi göstergesi. Yüzde doluluk, gerçek değer ve alarm seviyeleri gösterir.',

        slots: [
            { key: 'level', label: 'Seviye (%)', type: 'number', unit: '%' },
            { key: 'level_value', label: 'Gerçek Değer', type: 'number', unit: '' },
            { key: 'level_unit', label: 'Birim Metni', type: 'number', unit: '', default: '' },
            { key: 'high_alarm', label: 'Yüksek Alarm (%)', type: 'number', unit: '%', default: 90 },
            { key: 'low_alarm', label: 'Düşük Alarm (%)', type: 'number', unit: '%', default: 10 },
            { key: 'capacity', label: 'Tank Kapasitesi', type: 'number', unit: '', default: 1000 }
        ],

        html: `
        <div class="tank-level-widget h-100" style="font-family: 'Segoe UI', sans-serif; min-width: 180px; min-height: 320px;">
            <div class="card h-100 shadow-sm" style="background: #212631; color: #fff; border: 1px solid #5a6475;">
                <!-- Header -->
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold text-white" style="letter-spacing: 0.5px; font-size: 0.85rem;">{{title}}</span>
                    <span class="badge" id="{{uid}}_alarm_badge" style="font-size: 0.65rem; background: #3a3d52; color: #8a8ea8;">NORMAL</span>
                </div>

                <div class="card-body p-3 d-flex flex-column align-items-center justify-content-center">
                    
                    <!-- Üst Değer Göstergesi -->
                    <div class="text-center mb-2">
                        <div class="fw-bold font-monospace" id="{{uid}}_level_pct" style="font-size: 2rem; color: #3399ff; line-height: 1;">--%</div>
                        <div class="text-secondary" id="{{uid}}_level_real" style="font-size: 0.8rem;">-- </div>
                    </div>

                    <!-- Tank SVG -->
                    <div style="position: relative; width: 120px; height: 180px;">
                        <svg viewBox="0 0 120 200" style="width: 100%; height: 100%;">
                            <!-- Tank Gövde -->
                            <defs>
                                <linearGradient id="{{uid}}_tankGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" style="stop-color:#3399ff;stop-opacity:0.9" />
                                    <stop offset="100%" style="stop-color:#321fdb;stop-opacity:0.9" />
                                </linearGradient>
                                <clipPath id="{{uid}}_tankClip">
                                    <rect x="15" y="20" width="90" height="160" rx="6" ry="6"/>
                                </clipPath>
                            </defs>
                            
                            <!-- Tank Dış Çerçeve -->
                            <rect x="15" y="20" width="90" height="160" rx="6" ry="6" fill="none" stroke="#5a6475" stroke-width="2"/>
                            
                            <!-- Tank İç Arka Plan -->
                            <rect x="16" y="21" width="88" height="158" rx="5" ry="5" fill="#1a1e2a"/>
                            
                            <!-- Sıvı Doluluk (alttan yukarı) -->
                            <rect id="{{uid}}_tankFill" x="16" y="179" width="88" height="0" fill="url(#{{uid}}_tankGrad)" clip-path="url(#{{uid}}_tankClip)" style="transition: y 0.6s ease, height 0.6s ease;">
                            </rect>

                            <!-- Sıvı Dalga Efekti -->
                            <ellipse id="{{uid}}_tankWave" cx="60" cy="179" rx="44" ry="3" fill="rgba(255,255,255,0.15)" clip-path="url(#{{uid}}_tankClip)" style="transition: cy 0.6s ease;"/>

                            <!-- Yüksek Alarm Çizgisi -->
                            <line id="{{uid}}_highLine" x1="10" y1="36" x2="110" y2="36" stroke="#e55353" stroke-width="1" stroke-dasharray="4,3" opacity="0.6"/>
                            <text id="{{uid}}_highText" x="112" y="39" fill="#e55353" font-size="8" opacity="0.6">H</text>

                            <!-- Düşük Alarm Çizgisi -->
                            <line id="{{uid}}_lowLine" x1="10" y1="164" x2="110" y2="164" stroke="#f9b115" stroke-width="1" stroke-dasharray="4,3" opacity="0.6"/>
                            <text id="{{uid}}_lowText" x="112" y="167" fill="#f9b115" font-size="8" opacity="0.6">L</text>

                            <!-- Ölçek Çizgileri -->
                            <line x1="12" y1="20" x2="12" y2="180" stroke="#4f5d73" stroke-width="0.5"/>
                            <line x1="8" y1="20" x2="14" y2="20" stroke="#636f83" stroke-width="1"/>
                            <text x="2" y="24" fill="#636f83" font-size="7">100</text>
                            <line x1="8" y1="60" x2="14" y2="60" stroke="#636f83" stroke-width="1"/>
                            <text x="5" y="64" fill="#636f83" font-size="7">75</text>
                            <line x1="8" y1="100" x2="14" y2="100" stroke="#636f83" stroke-width="1"/>
                            <text x="5" y="104" fill="#636f83" font-size="7">50</text>
                            <line x1="8" y1="140" x2="14" y2="140" stroke="#636f83" stroke-width="1"/>
                            <text x="5" y="144" fill="#636f83" font-size="7">25</text>
                            <line x1="8" y1="180" x2="14" y2="180" stroke="#636f83" stroke-width="1"/>
                            <text x="8" y="192" fill="#636f83" font-size="7">0</text>

                            <!-- Tank Üstü (Kapak) -->
                            <rect x="30" y="12" width="60" height="10" rx="3" ry="3" fill="#3a3d52" stroke="#5a6475" stroke-width="1"/>
                            <rect x="55" y="5" width="10" height="9" rx="2" ry="2" fill="#4f5d73"/>
                        </svg>
                    </div>

                    <!-- Alt Bilgi -->
                    <div class="d-flex justify-content-between w-100 mt-2 px-1" style="font-size: 0.7rem; color: #636f83;">
                        <span>Kap: <span id="{{uid}}_capacity" style="color:#adb5bd;">--</span></span>
                        <span id="{{uid}}_status_text" style="color:#2eb85c;">● Normal</span>
                    </div>
                </div>
            </div>
        </div>
        `,

        renderer: {
            onUpdate: function(uid, data, elements) {
                const level = Math.min(100, Math.max(0, parseFloat(data.level) || 0));
                const highAlarm = parseFloat(data.high_alarm) || 90;
                const lowAlarm = parseFloat(data.low_alarm) || 10;
                const capacity = parseFloat(data.capacity) || 1000;

                // Tank doluluk hesabı (SVG koordinatları: y=20 üst, y=180 alt, yükseklik=160)
                const tankTop = 21;
                const tankHeight = 158;
                const fillHeight = (level / 100) * tankHeight;
                const fillY = tankTop + tankHeight - fillHeight;

                // Tank doluluk animasyonu
                const fillEl = document.getElementById(`${uid}_tankFill`);
                if (fillEl) {
                    fillEl.setAttribute('y', fillY);
                    fillEl.setAttribute('height', fillHeight);
                }

                // Dalga efekti pozisyonu
                const waveEl = document.getElementById(`${uid}_tankWave`);
                if (waveEl) {
                    waveEl.setAttribute('cy', fillY);
                }

                // Yüzde değer
                const pctEl = document.getElementById(`${uid}_level_pct`);
                if (pctEl) {
                    pctEl.textContent = level.toFixed(1) + '%';
                    // Renk: alarm durumuna göre
                    if (level >= highAlarm) pctEl.style.color = '#e55353';
                    else if (level <= lowAlarm) pctEl.style.color = '#f9b115';
                    else pctEl.style.color = '#3399ff';
                }

                // Gerçek değer
                const realEl = document.getElementById(`${uid}_level_real`);
                if (realEl && data.level_value !== undefined) {
                    realEl.textContent = parseFloat(data.level_value).toFixed(1) + (data.level_unit ? ' ' + data.level_unit : '');
                }

                // Kapasite
                const capEl = document.getElementById(`${uid}_capacity`);
                if (capEl) capEl.textContent = capacity;

                // Alarm çizgileri pozisyonu
                const highLineY = tankTop + tankHeight - (highAlarm / 100) * tankHeight;
                const lowLineY = tankTop + tankHeight - (lowAlarm / 100) * tankHeight;

                const highLine = document.getElementById(`${uid}_highLine`);
                const highText = document.getElementById(`${uid}_highText`);
                if (highLine) { highLine.setAttribute('y1', highLineY); highLine.setAttribute('y2', highLineY); }
                if (highText) highText.setAttribute('y', highLineY + 3);

                const lowLine = document.getElementById(`${uid}_lowLine`);
                const lowText = document.getElementById(`${uid}_lowText`);
                if (lowLine) { lowLine.setAttribute('y1', lowLineY); lowLine.setAttribute('y2', lowLineY); }
                if (lowText) lowText.setAttribute('y', lowLineY + 3);

                // Alarm badge & durum metni
                const badge = document.getElementById(`${uid}_alarm_badge`);
                const statusText = document.getElementById(`${uid}_status_text`);

                if (level >= highAlarm) {
                    if (badge) { badge.textContent = 'YÜKSEK'; badge.style.background = '#e55353'; badge.style.color = '#fff'; }
                    if (statusText) { statusText.innerHTML = '<span style="color:#e55353;">▲ Yüksek Alarm</span>'; }
                    // Tank rengi kırmızıya çevir
                    const grad = document.getElementById(`${uid}_tankGrad`);
                    if (grad) {
                        grad.children[0].style.stopColor = '#e55353';
                        grad.children[1].style.stopColor = '#c82333';
                    }
                } else if (level <= lowAlarm) {
                    if (badge) { badge.textContent = 'DÜŞÜK'; badge.style.background = '#f9b115'; badge.style.color = '#1e2130'; }
                    if (statusText) { statusText.innerHTML = '<span style="color:#f9b115;">▼ Düşük Alarm</span>'; }
                    const grad = document.getElementById(`${uid}_tankGrad`);
                    if (grad) {
                        grad.children[0].style.stopColor = '#f9b115';
                        grad.children[1].style.stopColor = '#d39e00';
                    }
                } else {
                    if (badge) { badge.textContent = 'NORMAL'; badge.style.background = '#3a3d52'; badge.style.color = '#8a8ea8'; }
                    if (statusText) { statusText.innerHTML = '<span style="color:#2eb85c;">● Normal</span>'; }
                    const grad = document.getElementById(`${uid}_tankGrad`);
                    if (grad) {
                        grad.children[0].style.stopColor = '#3399ff';
                        grad.children[1].style.stopColor = '#321fdb';
                    }
                }
            }
        }
    },

    // ================================================================
    // DİJİTAL SAAT WIDGET
    // Sistem saatini gösteren, birden fazla saat formatı seçeneği
    // ================================================================

    {
        id: 'digital_clock',
        name: 'Dijital Saat',
        description: 'Sistem saatini gösteren dijital saat widget. Sağa açılan menüden birden fazla saat formatı seçilebilir (24 saat, 12 saat, tarih, saniye, timezone).',

        slots: [
            { key: 'timezone_offset', label: 'Saat Dilimi Offset (saat)', type: 'number', unit: 'h', default: 0 }
        ],

        html: `
        <div class="digital-clock-widget h-100" id="{{uid}}_clock_root" style="font-family: 'Segoe UI', sans-serif; min-width: 240px; min-height: 160px; position: relative; user-select: none;">
            <div class="card h-100 shadow-sm" style="background: #212631; color: #fff; border: 1px solid #5a6475;">
                <!-- Header -->
                <div class="card-header d-flex justify-content-between align-items-center py-2" style="background: rgba(255,255,255,0.05); border-bottom: 1px solid #4f5d73;">
                    <span class="text-uppercase fw-bold text-white" style="letter-spacing: 0.5px; font-size: 0.85rem;">{{title}}</span>
                    <!-- Ayarlar Butonu -->
                    <button class="btn btn-sm p-0 border-0" id="{{uid}}_settings_btn" 
                            style="background: transparent; color: #8a8ea8; font-size: 1rem; line-height: 1; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; border-radius: 4px;"
                            onmouseover="this.style.background='rgba(255,255,255,0.1)'; this.style.color='#fff';"
                            onmouseout="this.style.background='transparent'; this.style.color='#8a8ea8';">
                        <i class="fas fa-cog"></i>
                    </button>
                </div>

                <div class="card-body p-0 d-flex flex-column align-items-center justify-content-center position-relative" style="overflow: hidden;">
                    
                    <!-- Ana Saat Göstergesi -->
                    <div class="text-center px-3 py-2" style="width: 100%;">
                        <!-- Büyük Saat -->
                        <div class="font-monospace fw-bold" id="{{uid}}_time_main" 
                             style="font-size: 2.8rem; line-height: 1.1; color: #e4e6eb; text-shadow: 0 0 20px rgba(51,153,255,0.3); letter-spacing: 2px;">
                            --:--
                        </div>
                        <!-- Saniye (opsiyonel) -->
                        <div class="font-monospace" id="{{uid}}_time_seconds" 
                             style="font-size: 1.2rem; color: #3399ff; margin-top: -2px; display: none;">
                            :--
                        </div>
                        <!-- AM/PM (opsiyonel) -->
                        <div class="fw-bold" id="{{uid}}_time_ampm" 
                             style="font-size: 0.9rem; color: #f9b115; display: none; margin-top: 2px;">
                        </div>
                        <!-- Tarih (opsiyonel) -->
                        <div id="{{uid}}_date_display" 
                             style="font-size: 0.8rem; color: #636f83; margin-top: 6px; display: none;">
                        </div>
                        <!-- Gün Adı (opsiyonel) -->
                        <div id="{{uid}}_day_display" 
                             style="font-size: 0.75rem; color: #8a8ea8; text-transform: uppercase; letter-spacing: 1px; display: none;">
                        </div>
                        <!-- Timezone Etiketi (opsiyonel) -->
                        <div id="{{uid}}_tz_display" 
                             style="font-size: 0.65rem; color: #4f5d73; margin-top: 4px; display: none;">
                        </div>
                    </div>

                    <!-- Sağa Açılan Ayarlar Paneli -->
                    <div id="{{uid}}_settings_panel" 
                         style="position: absolute; top: 0; right: -260px; width: 250px; height: 100%; background: #1a1e2a; border-left: 1px solid #4f5d73; padding: 12px; z-index: 10; transition: right 0.3s ease; overflow-y: auto;">
                        
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="fw-bold text-white" style="font-size: 0.85rem;">Saat Seçenekleri</span>
                            <button class="btn btn-sm p-0 border-0" id="{{uid}}_close_panel" 
                                    style="background: transparent; color: #8a8ea8; font-size: 0.9rem;">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Seçenekler -->
                        <div style="font-size: 0.8rem;">
                            <!-- Format -->
                            <div class="mb-3">
                                <div class="text-muted text-uppercase mb-1" style="font-size: 0.65rem; letter-spacing: 0.5px;">Saat Formatı</div>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="radio" name="{{uid}}_fmt" value="24h" checked class="{{uid}}_opt" style="accent-color: #3399ff;">
                                    <span class="text-light">24 Saat</span>
                                    <span class="ms-auto text-secondary" style="font-size:0.7rem;">14:30</span>
                                </label>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="radio" name="{{uid}}_fmt" value="12h" class="{{uid}}_opt" style="accent-color: #3399ff;">
                                    <span class="text-light">12 Saat</span>
                                    <span class="ms-auto text-secondary" style="font-size:0.7rem;">2:30 PM</span>
                                </label>
                            </div>

                            <!-- Gösterilecek Bilgiler -->
                            <div class="mb-3">
                                <div class="text-muted text-uppercase mb-1" style="font-size: 0.65rem; letter-spacing: 0.5px;">Gösterilecek Bilgiler</div>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="checkbox" class="{{uid}}_opt" data-target="seconds" style="accent-color: #3399ff;">
                                    <span class="text-light">Saniye</span>
                                </label>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="checkbox" class="{{uid}}_opt" data-target="date" checked style="accent-color: #3399ff;">
                                    <span class="text-light">Tarih</span>
                                </label>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="checkbox" class="{{uid}}_opt" data-target="day" style="accent-color: #3399ff;">
                                    <span class="text-light">Gün Adı</span>
                                </label>
                                <label class="d-flex align-items-center gap-2 mb-1 px-2 py-1 rounded" style="cursor:pointer; background: rgba(255,255,255,0.03);">
                                    <input type="checkbox" class="{{uid}}_opt" data-target="timezone" style="accent-color: #3399ff;">
                                    <span class="text-light">Saat Dilimi</span>
                                </label>
                            </div>

                            <!-- Tema -->
                            <div class="mb-2">
                                <div class="text-muted text-uppercase mb-1" style="font-size: 0.65rem; letter-spacing: 0.5px;">Renk Teması</div>
                                <div class="d-flex gap-2 flex-wrap">
                                    <button class="{{uid}}_theme_btn btn btn-sm p-0 rounded-circle border-0" data-color="#3399ff" 
                                            style="width:24px; height:24px; background:#3399ff; outline: 2px solid #3399ff; outline-offset: 2px;"></button>
                                    <button class="{{uid}}_theme_btn btn btn-sm p-0 rounded-circle border-0" data-color="#2eb85c" 
                                            style="width:24px; height:24px; background:#2eb85c;"></button>
                                    <button class="{{uid}}_theme_btn btn btn-sm p-0 rounded-circle border-0" data-color="#e55353" 
                                            style="width:24px; height:24px; background:#e55353;"></button>
                                    <button class="{{uid}}_theme_btn btn btn-sm p-0 rounded-circle border-0" data-color="#f9b115" 
                                            style="width:24px; height:24px; background:#f9b115;"></button>
                                    <button class="{{uid}}_theme_btn btn btn-sm p-0 rounded-circle border-0" data-color="#e4e6eb" 
                                            style="width:24px; height:24px; background:#e4e6eb;"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `,

        renderer: {
            _timers: {},
            _settings: {},
            
            onUpdate: function(uid, data, elements) {
                const self = window.WIDGET_TEMPLATES.find(t => t.id === 'digital_clock').renderer;
                
                // İlk çağrıda saat timer'ını ve event listener'ları kur
                if (!self._timers[uid]) {
                    // Varsayılan ayarlar
                    self._settings[uid] = {
                        format: '24h',
                        showSeconds: false,
                        showDate: true,
                        showDay: false,
                        showTimezone: false,
                        accentColor: '#3399ff',
                        tzOffset: 0
                    };

                    const gunler = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
                    const aylar = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

                    // Saat güncelleme fonksiyonu
                    const updateClock = () => {
                        const s = self._settings[uid];
                        const now = new Date();
                        
                        // Timezone offset uygula
                        if (s.tzOffset !== 0) {
                            now.setHours(now.getHours() + s.tzOffset);
                        }

                        let hours = now.getHours();
                        const mins = now.getMinutes().toString().padStart(2, '0');
                        const secs = now.getSeconds().toString().padStart(2, '0');
                        let ampm = '';

                        if (s.format === '12h') {
                            ampm = hours >= 12 ? 'PM' : 'AM';
                            hours = hours % 12;
                            if (hours === 0) hours = 12;
                        }

                        const hoursStr = hours.toString().padStart(2, '0');

                        // Ana saat
                        const mainEl = document.getElementById(`${uid}_time_main`);
                        if (mainEl) {
                            mainEl.textContent = `${hoursStr}:${mins}`;
                            mainEl.style.textShadow = `0 0 20px ${s.accentColor}40`;
                        }

                        // Saniye
                        const secEl = document.getElementById(`${uid}_time_seconds`);
                        if (secEl) {
                            secEl.textContent = `:${secs}`;
                            secEl.style.display = s.showSeconds ? 'block' : 'none';
                            secEl.style.color = s.accentColor;
                        }

                        // AM/PM
                        const ampmEl = document.getElementById(`${uid}_time_ampm`);
                        if (ampmEl) {
                            ampmEl.textContent = ampm;
                            ampmEl.style.display = (s.format === '12h') ? 'block' : 'none';
                        }

                        // Tarih
                        const dateEl = document.getElementById(`${uid}_date_display`);
                        if (dateEl) {
                            const day = now.getDate();
                            const month = aylar[now.getMonth()];
                            const year = now.getFullYear();
                            dateEl.textContent = `${day} ${month} ${year}`;
                            dateEl.style.display = s.showDate ? 'block' : 'none';
                        }

                        // Gün adı
                        const dayEl = document.getElementById(`${uid}_day_display`);
                        if (dayEl) {
                            dayEl.textContent = gunler[now.getDay()];
                            dayEl.style.display = s.showDay ? 'block' : 'none';
                        }

                        // Timezone
                        const tzEl = document.getElementById(`${uid}_tz_display`);
                        if (tzEl) {
                            const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            const offsetStr = s.tzOffset !== 0 ? ` (UTC${s.tzOffset >= 0 ? '+' : ''}${s.tzOffset})` : '';
                            tzEl.textContent = localTz + offsetStr;
                            tzEl.style.display = s.showTimezone ? 'block' : 'none';
                        }
                    };

                    // Timer başlat (her saniye)
                    self._timers[uid] = setInterval(updateClock, 1000);
                    updateClock(); // İlk güncelleme hemen

                    // --- Event Listeners ---

                    // Ayarlar paneli açma/kapama
                    const settingsBtn = document.getElementById(`${uid}_settings_btn`);
                    const settingsPanel = document.getElementById(`${uid}_settings_panel`);
                    const closeBtn = document.getElementById(`${uid}_close_panel`);

                    if (settingsBtn && settingsPanel) {
                        settingsBtn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const isOpen = settingsPanel.style.right === '0px';
                            settingsPanel.style.right = isOpen ? '-260px' : '0px';
                        });
                    }
                    if (closeBtn && settingsPanel) {
                        closeBtn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            settingsPanel.style.right = '-260px';
                        });
                    }

                    // Panel dışına tıklayınca kapat
                    document.addEventListener('click', (e) => {
                        if (settingsPanel && settingsPanel.style.right === '0px') {
                            const root = document.getElementById(`${uid}_clock_root`);
                            if (root && !root.contains(e.target)) {
                                settingsPanel.style.right = '-260px';
                            }
                        }
                    });

                    // Format radio butonları
                    const radios = document.querySelectorAll(`input[name="${uid}_fmt"]`);
                    radios.forEach(radio => {
                        radio.addEventListener('change', () => {
                            self._settings[uid].format = radio.value;
                            updateClock();
                        });
                    });

                    // Checkbox seçenekleri
                    const checkboxes = document.querySelectorAll(`.${uid}_opt[type="checkbox"]`);
                    checkboxes.forEach(cb => {
                        const target = cb.dataset.target;
                        // Başlangıç durumu
                        if (target === 'date') self._settings[uid].showDate = cb.checked;
                        
                        cb.addEventListener('change', () => {
                            const s = self._settings[uid];
                            if (target === 'seconds') s.showSeconds = cb.checked;
                            else if (target === 'date') s.showDate = cb.checked;
                            else if (target === 'day') s.showDay = cb.checked;
                            else if (target === 'timezone') s.showTimezone = cb.checked;
                            updateClock();
                        });
                    });

                    // Renk tema butonları
                    const themeButtons = document.querySelectorAll(`.${uid}_theme_btn`);
                    themeButtons.forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const color = btn.dataset.color;
                            self._settings[uid].accentColor = color;
                            
                            // Aktif buton vurgula
                            themeButtons.forEach(b => { b.style.outline = 'none'; b.style.outlineOffset = '0'; });
                            btn.style.outline = `2px solid ${color}`;
                            btn.style.outlineOffset = '2px';
                            
                            updateClock();
                        });
                    });
                }

                // Timezone offset güncellemesi (tag üzerinden)
                if (data.timezone_offset !== undefined) {
                    self._settings[uid].tzOffset = parseFloat(data.timezone_offset) || 0;
                }
            }
        }
    }
];

// Export if module system is used, or attach to window
if (typeof module !== 'undefined' && module.exports) {
    module.exports = WIDGET_TEMPLATES;
} else {
    window.WIDGET_TEMPLATES = WIDGET_TEMPLATES;
}
